<template>
  <div v-if="!isMobile()" class="loading_screen">
    <img src="/assets/loader_screen.gif" alt="Loading" />
  </div>
  <div class="loading_screen" v-else>
    <v-progress-circular
      :rotate="360"
      :size="100"
      :width="15"
      :model-value="value"
      color="teal"
    >
      {{ value }}
    </v-progress-circular>
  </div>
</template>
<script>
export default {
  data() {
    return {
      interval: {},
      value: 0
    };
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.value === 100) {
        return (this.value = 0);
      }
      this.value += 10;
    }, 1000);
  }
};
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}

.loading_screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
